"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iDeleteReportRequest = exports.iCreateReportOrTemplateRequest = exports.iCreateOrExportReportRequest = exports.iUpdateTemplateRequest = exports.iCreateTemplateRequest = exports.iCreateReportRequest = exports.iExportReportRequest = exports.iTimezone = exports.iReport = exports.iReportTemplate = exports.iReportField = exports.ReportStatus = exports.FAILED = exports.COMPLETED = exports.IN_PROGRESS = void 0;
const t = require("io-ts");
const User = require("./user");
exports.IN_PROGRESS = 'IN_PROGRESS';
exports.COMPLETED = 'COMPLETED';
exports.FAILED = 'FAILED';
exports.ReportStatus = {
    [exports.IN_PROGRESS]: { id: 1, name: exports.IN_PROGRESS },
    [exports.COMPLETED]: { id: 2, name: exports.COMPLETED },
    [exports.FAILED]: { id: 3, name: exports.FAILED }
};
exports.iReportField = t.interface({
    id: t.number,
    fieldName: t.string,
    categoryName: t.string,
    subcategoryName: t.union([t.string, t.null])
});
exports.iReportTemplate = t.intersection([
    t.interface({
        id: t.number,
        uuid: t.string,
        name: t.string,
        description: t.string,
        createdAt: t.number,
        createdBy: User.iAuthorName,
        updatedAt: t.union([t.number, t.null]),
        updatedBy: t.union([User.iAuthorName, t.null])
    }),
    t.partial({
        selectedFields: t.array(t.string)
    })
]);
const ReportLocaleProps = t.partial({
    language: t.string,
    timezone: t.string
});
exports.iReport = t.intersection([
    exports.iReportTemplate,
    t.interface({
        expiresAt: t.union([t.number, t.null]),
        status: t.string
    }),
    ReportLocaleProps
]);
exports.iTimezone = t.interface({
    name: t.string,
    timezone: t.string,
    offset: t.string
});
exports.iExportReportRequest = t.intersection([
    t.interface({
        customerId: t.number,
        templateUuid: t.string
    }),
    ReportLocaleProps
]);
exports.iCreateReportRequest = t.intersection([
    t.interface({
        customerId: t.number,
        fields: t.array(t.string)
    }),
    ReportLocaleProps
]);
exports.iCreateTemplateRequest = t.intersection([
    exports.iCreateReportRequest,
    t.interface({
        name: t.string
    }),
    t.partial({
        description: t.string
    })
]);
exports.iUpdateTemplateRequest = t.partial({
    name: t.string,
    description: t.string,
    fields: t.array(t.string)
});
exports.iCreateOrExportReportRequest = t.union([
    exports.iCreateReportRequest,
    exports.iExportReportRequest
]);
exports.iCreateReportOrTemplateRequest = t.union([
    t.intersection([
        t.interface({ type: t.literal('REPORT') }),
        exports.iCreateReportRequest
    ]),
    t.intersection([
        t.interface({ type: t.literal('TEMPLATE') }),
        exports.iCreateTemplateRequest
    ])
]);
exports.iDeleteReportRequest = t.interface({
    customerId: t.number,
    uuids: t.array(t.string)
});
//# sourceMappingURL=reports.js.map